module.exports = __webpack_public_path__ + "static/media/space-station-moon.6c488ede.svg";